import { popupModel } from '@_entities/system';
import { PromotionPopup } from '@_shared/ui/Popup';
import { handleOnPopupButtonClick } from '../../libs';

interface IMGPopupProps {
	popup: popupModel.IImagePopup;
	handleClose: () => void;
}

export function IMGPopup({ popup, handleClose }: IMGPopupProps) {
	return (
		<PromotionPopup.Container closePopup={handleClose}>
			{popup.deleteButtonEnabled && <PromotionPopup.CloseIcon onClose={handleClose} />}
			<PromotionPopup.Img
				src={popup.body.image.imageURL}
				alt="event popup image"
				onClick={() => {
					window.location.href = popup.body.image.redirectURL;
				}}
			/>
			<PromotionPopup.ButtonContainer>
				{popup.buttons.map((button) => (
					<PromotionPopup.Button
						type={button.color === 'orange' ? 'confirm' : 'deny'}
						onClick={() => {
							handleOnPopupButtonClick(button, handleClose, popup.id);
						}}
					>
						{button.text}
					</PromotionPopup.Button>
				))}
			</PromotionPopup.ButtonContainer>
		</PromotionPopup.Container>
	);
}
